import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import IncidentsLayer from '@/constants/layers/incidentsLayer'
import type { LayerInfo } from '@/types/LayerInfo'

// There is no external incident feed for North Africa: incidents are created in WildfireSAFE itself
const info: LayerInfo = {
  description: {
    'en-US': 'Incidents for this region are created directly within WildfireSAFE.',
    'es-ES': 'Los incidentes de esta región se crean directamente en WildfireSAFE.',
    'pt-BR': 'Os incidentes desta região são criados diretamente no WildfireSAFE.',
    'fr-FR': 'Les incidents de cette région sont créés directement dans WildfireSAFE.'
  }
}

const incidentsNorthAfrica = {
  ...IncidentsLayer,
  customProperties: { ...IncidentsLayer.customProperties, info }
} as LayerRaw

export default incidentsNorthAfrica
